<!--AboutSchool:学校解决方案 2021/12/20 14:05:33 YuAng-->

<template>
  <div class="ho-mobile-school">
    <mobile-banner :item="banner"></mobile-banner>
    <div class="ho-page-part2">
      <p class="ho-part-title">学校智慧教学全场景，一站式解决</p>
      <p>
        <img width="100%" src="../../../../assets/images/mobile/school_part2_intro.png" />
      </p>
    </div>
    <product-intro :tabs="tabs"></product-intro>
  </div>
</template>
<script>
import MobileBanner from '../components/MobileBanner.vue'
import ProductIntro from '../components/ProductIntro.vue'
export default {
  components: { MobileBanner, ProductIntro },
  name: 'AboutSchool',
  props: {
    item: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data() {
    return {
      banner: {
        name: 'school',
        title: '以优质数字资源为内核的学校智慧教学解决方案',
        desc: '打造“教、学、管、评、测、研”智慧教学闭环，为教师增效，为学生减负，帮助学校科学管理，让教与学更高效',
        url: 'https://oss-ts-prod.oss-cn-hangzhou.aliyuncs.com/lecture/public/ued-video/ued-15.mp4'
      },
      tabs: [
        {
          id: 1,
          mainTitle: '数字资源',
          children: [
            {
              id: 1,
              title: '优质教学资源',
              desc: '覆盖全学段、全学科、全教材版本、全类型，满足多种教学需求。',
              imgCount: 2,
              device: 'pc'
            },
            {
              id: 2,
              title: '精品自学资源',
              desc: '精选同步巩固资源、专项突破内容，分层靶向提升。',
              imgCount: 1,
              device: 'pad'
            },
            {
              id: 3,
              title: '特色学科资源',
              desc: '英语学科特色专题内容，听说读写系统训练，口语、作文智能测评。',
              imgCount: 2,
              device: 'pc'
            }
          ]
        },
        {
          id: 2,
          mainTitle: '智慧教学',
          children: [
            {
              id: 1,
              title: '轻松备课',
              desc: '资源智能推荐、文件在线编辑、集体协同备课，让备课更轻松、更高效。',
              imgCount: 2,
              device: 'pc'
            },
            {
              id: 2,
              title: '高效授课',
              desc: '师生互动，随堂检测，即时反馈，打造多元趣味课堂。',
              imgCount: 2,
              device: 'pc'
            },
            {
              id: 3,
              title: '课后训练',
              desc: '科学分层布置，支持自动批改，精准学情分析，灵活高效讲评。',
              imgCount: 2,
              device: 'pc'
            },
            {
              id: 4,
              title: '智能考评',
              desc: '智能题库采用“AI算法+老师助力+专家诊断”，输出教师讲评、学生个性化考试报告。',
              imgCount: 2,
              device: 'pc'
            },
            {
              id: 5,
              title: '学情诊断',
              desc: '基于全流程数据分析，生成个性化辅导方案，助力精准教学、靶向提升。',
              imgCount: 1,
              device: 'pc'
            }
          ]
        },
        {
          id: 3,
          mainTitle: '智慧研训',
          children: [
            {
              id: 1,
              title: '智慧研训',
              desc: '提供教师专业培训与研修服务，助力教师基本技能提升与职业发展，帮助教师上好每一堂课。',
              imgCount: 2,
              device: 'pc'
            }
          ]
        },
        {
          id: 4,
          mainTitle: '智慧学习',
          children: [
            {
              id: 1,
              title: '智慧学习',
              desc: '提供丰富学生自学资源，教材同步、专项突破，助力学生个性化学习，巩固课堂学习成果。',
              imgCount: 2,
              device: 'pad'
            }
          ]
        },
        {
          id: 5,
          mainTitle: '智慧管理',
          children: [
            {
              id: 1,
              title: '精准学情',
              desc: '多维度学情数据全面记录、客观分析，辅助教学策略调整。',
              imgCount: 2,
              device: 'pc'
            },
            {
              id: 2,
              title: '教学评价',
              desc: '多维度学生评价体系，助力推进学风、德育、校风建设。',
              imgCount: 1,
              device: 'pc'
            },
            {
              id: 3,
              title: '科学管理',
              desc: '纵览全校教学动态，多维度分析，教学评比有据可依，助力学校科学管理。',
              imgCount: 2,
              device: 'pc'
            },
            {
              id: 4,
              title: '家校互联',
              desc: '家校互通互联，实时了解孩子在校动态，促进家校共育。',
              imgCount: 1,
              device: 'app'
            }
          ]
        }
      ]
    }
  }
}
</script>

<style scoped>
.ho-mobile-school >>> .ho-mobile-banner p {
  margin-bottom: 24px;
}

.ho-mobile-school >>> .ho-mobile-banner p.title {
  padding: 0 32px;
}

.ho-page-part2 {
  background: white;
  padding: 16px 8px 32px 8px;
}
</style>